var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 38.3999C21.851 38.3999 24 36.2509 24 33.5999V28.7999H19.2C16.549 28.7999 14.4 30.949 14.4 33.5999C14.4 36.2509 16.549 38.3999 19.2 38.3999Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 24C14.4 21.349 16.549 19.2 19.2 19.2H24V28.8H19.2C16.549 28.8 14.4 26.6509 14.4 24Z",
    fill: "#A259FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4C14.4 11.749 16.549 9.59998 19.2 9.59998H24V19.2H19.2C16.549 19.2 14.4 17.0509 14.4 14.4Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.59998H28.8C31.451 9.59998 33.6 11.749 33.6 14.4C33.6 17.0509 31.451 19.2 28.8 19.2H24V9.59998Z",
    fill: "#FF7262"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 24C33.6 26.6509 31.451 28.8 28.8 28.8C26.149 28.8 24 26.6509 24 24C24 21.349 26.149 19.2 28.8 19.2C31.451 19.2 33.6 21.349 33.6 24Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.d8b3b9b975bfefd26917b8c8d002c151.svg";
export { ForwardRef as ReactComponent };